import { api } from './client'

export async function listUsers() {
  const { data } = await api.get('/users')
  return data
}

export async function createUser(body) {
  const { data } = await api.post('/users', body)
  return data
}

export async function updateUser(userId, body) {
  const { data } = await api.patch(`/users/${userId}`, body)
  return data
}

export async function deleteUser(userId) {
  await api.delete(`/users/${userId}`)
}
